import { useEffect } from 'react';

const ZohoCRMScript = () => {
  useEffect(() => {
    // Security check: Only load scripts in production or when explicitly enabled
    if (process.env.NODE_ENV !== 'production' && !window.location.search.includes('enableZohoScripts')) {
      console.warn('Zoho CRM scripts disabled in development for security');
      return;
    }
    // Add the required styles for Zoho CRM forms
    const style = document.createElement('style');
    style.textContent = `
      html,body{
        margin: 0px;
      }
      .formsubmit.zcwf_button{
        color: white !important;
        background: transparent linear-gradient(0deg, #0279FF 0%, #00A3F3 100%);
      }
      #crmWebToEntityForm.zcwf_lblLeft{
        width: 100%;
        padding: 25px;
        margin: 0 auto;
        box-sizing: border-box;
      }
      #crmWebToEntityForm.zcwf_lblLeft *{
        box-sizing: border-box;
      }
      #crmWebToEntityForm {text-align: left;
      }
      #crmWebToEntityForm *{
      direction: ltr;
      }
      .zcwf_lblLeft .zcwf_title{
      word-wrap: break-word;
      padding: 0px 6px 10px;
      font-weight: bold }
      .zcwf_lblLeft.cpT_primaryBtn:hover{
      background: linear-gradient(#02acff 0,#006be4 100%)no-repeat padding-box !important;
      box-shadow: 0 -2px 0 0  #0159b9 inset !important;
      border: 0 !important;
      color:  #fff !important;
      outline: 0 !important;
      }
      .zcwf_lblLeft .zcwf_col_fld input[type = text], input[type = password], .zcwf_lblLeft .zcwf_col_fld textarea{
      width: 60%;
      border: 1px solid  #c0c6cc !important;
      resize: vertical;
      border-radius: 2px;
      float: left;
      }
      .zcwf_lblLeft .zcwf_col_lab{
      width: 30%;
      word-break: break-word;
      padding: 0px 6px 0px;
      margin-right: 10px;
      margin-top: 5px;
      float: left;
      min-height: 1px;
      }
      .zcwf_lblLeft .zcwf_col_fld{
      float: left;
      width: 68%;
      padding: 0px 6px 0px;
      position: relative;
      margin-top: 5px;
      }
      .zcwf_lblLeft .zcwf_privacy {padding: 6px;
      }
      .zcwf_lblLeft .wfrm_fld_dpNn {display: none;
      }
      .dIB {display: inline-block;
      }
      .zcwf_lblLeft .zcwf_col_fld_slt{
      width: 60%;
      border: 1px solid  #ccc;
      background:  #fff;
      border-radius: 4px;
      font-size: 12px;
      float: left;
      resize: vertical;
      padding: 2px 5px;
      }
      .zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after{
      content: '';
      display: table;
      clear: both;
      }
      .zcwf_lblLeft .zcwf_col_help{
      float: left;
      margin-left: 7px;
      font-size: 12px;
      max-width: 35%;
      word-break: break-word;
      }
      .zcwf_lblLeft .zcwf_help_icon{
      cursor: pointer;
      width: 16px;
      height: 16px;
      display: inline-block;
      background:  #fff;
      border: 1px solid  #c0c6cc;
      color:  #c1c1c1;
      text-align: center;
      font-size: 11px;
      line-height: 16px;
      font-weight: bold;
      border-radius: 50%;
      }
      .zcwf_lblLeft .zcwf_row {margin: 15px 0px;
      }
      .zcwf_lblLeft .formsubmit{
      margin-right: 5px;
      cursor: pointer;
      color:  #313949;
      font-size: 12px;
      }
      .zcwf_lblLeft .zcwf_privacy_txt{
      width: 90%;
      color: rgb(0, 0, 0);
      font-size: 12px;
      font-family: Arial;
      display: inline-block;
      vertical-align: top;
      color:  #313949;
      padding-top: 2px;
      margin-left: 6px;
      }
      .zcwf_lblLeft .zcwf_button{
      font-size: 12px;
      color:  #313949;
      border: 1px solid  #c0c6cc;
      padding: 3px 9px;
      border-radius: 4px;
      cursor: pointer;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      }
      .zcwf_lblLeft .zcwf_tooltip_over{
      position: relative;
      }
      .zcwf_lblLeft .zcwf_tooltip_ctn{
      position: absolute;
      background:  #dedede;
      padding: 3px 6px;
      top: 3px;
      border-radius: 4px;
      word-break: break-word;
      min-width: 100px;
      max-width: 150px;
      color:  #313949;
      z-index: 100;
      }
      .zcwf_lblLeft .zcwf_ckbox{
      float: left;
      }
      .zcwf_lblLeft .zcwf_file{
      width: 55%;
      box-sizing: border-box;
      float: left;
      }
      .cBoth:after{
      content: '';
      display: block;
      clear: both;
      }
      /* New styles for the partner form */
      #crmWebToEntityForm.zcwf_lblTopBottom{
        width: 100%;
        padding: 25px;
        margin: 0 auto;
        box-sizing: border-box;
      }
      #crmWebToEntityForm.zcwf_lblTopBottom *{
        box-sizing: border-box;
      }
      .zcwf_lblTopBottom .zcwf_title{
        word-wrap: break-word;
        padding: 0px 6px 10px;
        font-weight: bold;
      }
      .zcwf_lblTopBottom.cpT_primaryBtn:hover{
        background: linear-gradient(#02acff 0,#006be4 100%)no-repeat padding-box !important;
        box-shadow: 0 -2px 0 0  #0159b9 inset !important;
        border: 0 !important;
        color:  #fff !important;
        outline: 0 !important;
      }
      .zcwf_lblTopBottom .zcwf_col_fld input[type = text], input[type = password], .zcwf_lblTopBottom .zcwf_col_fld textarea{
        width: 60%;
        border: 1px solid  #c0c6cc !important;
        resize: vertical;
        border-radius: 2px;
        float: left;
      }
      .zcwf_lblTopBottom .zcwf_col_lab{
        width: 30%;
        word-break: break-word;
        padding: 0px 6px 0px;
        margin-right: 10px;
        margin-top: 5px;
        padding-bottom: 4px;
      }
      .zcwf_lblTopBottom .zcwf_col_fld{
        width: 60%;
        padding: 0px 6px 0px;
        position: relative;
        margin-top: 5px;
      }
      .zcwf_lblTopBottom .zcwf_privacy {
        padding: 6px;
      }
      .zcwf_lblTopBottom .wfrm_fld_dpNn {
        display: none;
      }
      .zcwf_lblTopBottom .zcwf_col_fld_slt{
        width: 60%;
        border: 1px solid  #ccc;
        background:  #fff;
        border-radius: 4px;
        font-size: 12px;
        float: left;
        resize: vertical;
        padding: 2px 5px;
      }
      .zcwf_lblTopBottom .zcwf_row:after, .zcwf_lblTopBottom .zcwf_col_fld:after{
        content: '';
        display: table;
        clear: both;
      }
      .zcwf_lblTopBottom .zcwf_col_help{
        float: left;
        margin-left: 7px;
        font-size: 12px;
        max-width: 35%;
        word-break: break-word;
      }
      .zcwf_lblTopBottom .zcwf_help_icon{
        cursor: pointer;
        width: 16px;
        height: 16px;
        display: inline-block;
        background:  #fff;
        border: 1px solid  #c0c6cc;
        color:  #c1c1c1;
        text-align: center;
        font-size: 11px;
        line-height: 16px;
        font-weight: bold;
        border-radius: 50%;
      }
      .zcwf_lblTopBottom .zcwf_row {
        margin: 15px 0px;
      }
      .zcwf_lblTopBottom .formsubmit{
        margin-right: 5px;
        cursor: pointer;
        color:  #313949;
        font-size: 12px;
      }
      .zcwf_lblTopBottom .zcwf_privacy_txt{
        width: 90%;
        color: rgb(0, 0, 0);
        font-size: 12px;
        font-family: Arial;
        display: inline-block;
        vertical-align: top;
        color:  #313949;
        padding-top: 2px;
        margin-left: 6px;
      }
      .zcwf_lblTopBottom .zcwf_button{
        font-size: 12px;
        color:  #313949;
        border: 1px solid  #c0c6cc;
        padding: 3px 9px;
        border-radius: 4px;
        cursor: pointer;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .zcwf_lblTopBottom .zcwf_tooltip_over{
        position: relative;
      }
      .zcwf_lblTopBottom .zcwf_tooltip_ctn{
        position: absolute;
        background:  #dedede;
        padding: 3px 6px;
        top: 3px;
        border-radius: 4px;
        word-break: break-word;
        min-width: 100px;
        max-width: 150px;
        color:  #313949;
        z-index: 100;
      }
      .zcwf_lblTopBottom .zcwf_ckbox{
        float: left;
      }
      .zcwf_lblTopBottom .zcwf_file{
        width: 35%;
        box-sizing: border-box;
        float: left;
      }
      @media all and  (max-width: 600px){
      .zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld{
      width: auto;
      float: none !important;
      }
      .zcwf_lblLeft .zcwf_col_help {width: 40%;
      }
      .zcwf_lblTopBottom .zcwf_col_lab, .zcwf_lblTopBottom .zcwf_col_fld{
      width: auto;
      float: none !important;
      }
      .zcwf_lblTopBottom .zcwf_col_help {width: 40%;
      }
      }
    `;
    document.head.appendChild(style);

    // Add the required JavaScript functions
    const script = document.createElement('script');
    script.textContent = `
      function validateEmail966770000000572001(){
        var form = document.forms['WebToLeads966770000000572001'];
        var emailFld = form.querySelectorAll('[ftype=email]');
        var i;
        for(i = 0; i < emailFld.length; i++){
          var emailVal = emailFld[i].value;
          if((emailVal.replace(/^\\s+|\\s+$/g, '')).length != 0){
            var atpos = emailVal.indexOf('@');
            var dotpos = emailVal.lastIndexOf('.');
            if(atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length){
              alert('Please enter a valid email address.');
              emailFld[i].focus();
              return false;
            }
          }
        }
        return true;
      }

      function checkMandatory966770000000572001(){
        var mndFileds = new Array('Company', 'First Name', 'Last Name', 'Email', 'Description');
        var fldLangVal = new Array('Company', 'First Name', 'Last Name', 'Work Email', 'How can we help?');
        for(i = 0; i < mndFileds.length; i++){
          var fieldObj = document.forms['WebToLeads966770000000572001'][mndFileds[i]];
          if(fieldObj){
            if(((fieldObj.value).replace(/^\\s+|\\s+$/g, '')).length == 0){
              if(fieldObj.type == 'file'){
                alert('Please select a file to upload.');
                fieldObj.focus();
                return false;
              }
              alert(fldLangVal[i] + ' cannot be empty.');
              fieldObj.focus();
              return false;
            }
            else if(fieldObj.nodeName == 'SELECT'){
              if(fieldObj.options[fieldObj.selectedIndex].value == '-None-'){
                alert(fldLangVal[i] + ' cannot be none.');
                fieldObj.focus();
                return false;
              }
            }
            else if(fieldObj.type == 'checkbox'){
              if(fieldObj.checked == false){
                alert('Please accept ' + fldLangVal[i]);
                fieldObj.focus();
                return false;
              }
            }
            try{
              if(fieldObj.name == 'Last Name'){
                name = fieldObj.value;
              }
            }
            catch(e){}
          }
        }
        if(!validateEmail966770000000572001()){
          return false;
        }
        var urlparams = new URLSearchParams(window.location.search);
        if(urlparams.has('service') && (urlparams.get('service') === 'smarturl')){
          var webform = document.getElementById('webform966770000000572001');
          var service = urlparams.get('service');
          var smarturlfield = document.createElement('input');
          smarturlfield.setAttribute('type', 'hidden');
          smarturlfield.setAttribute('value', service);
          smarturlfield.setAttribute('name', 'service');
          webform.appendChild(smarturlfield);
        }
        document.querySelector('.crmWebToEntityForm .formsubmit').setAttribute('disabled', true);
      }

      function tooltipShow966770000000572001(el){
        var tooltip = el.nextElementSibling;
        var tooltipDisplay = tooltip.style.display;
        if(tooltipDisplay == 'none'){
          var allTooltip = document.getElementsByClassName('zcwf_tooltip_over');
          for(i = 0; i < allTooltip.length; i++){
            allTooltip[i].style.display = 'none';
          }
          tooltip.style.display = 'block';
        }
        else{
          tooltip.style.display = 'none';
        }
      }

      // Functions for the new partner form (966770000000627837)
      function addAriaSelected966770000000627837(){
        var optionElem = event.target;
        var previousSelectedOption = optionElem.querySelector('[aria-selected=true]');
        if(previousSelectedOption){
          previousSelectedOption.removeAttribute('aria-selected');
        }
        optionElem.querySelectorAll('option')[optionElem.selectedIndex].ariaSelected = 'true';
      }
      
      function privacyAlert966770000000627837(){
        var privacyTool = document.getElementById('privacyTool966770000000627837');
        var privacyErr = document.getElementById('privacyErr966770000000627837');
        if(privacyTool != undefined && !privacyTool.checked){
          privacyErr.style.visibility = 'visible';
          privacyTool.ariaInvalid = 'true';
          privacyTool.focus();
          return false;
        }
        return true;
      }
      
      function disableErr966770000000627837(){
        var privacyTool = document.getElementById('privacyTool966770000000627837');
        var privacyErr = document.getElementById('privacyErr966770000000627837');
        if(privacyTool != undefined && privacyTool.checked && privacyErr != undefined){
          privacyErr.style.visibility = 'hidden';
          privacyTool.ariaInvalid = 'false';
        }
      }
      
      function validateEmail966770000000627837(){
        var form = document.forms['WebToLeads966770000000627837'];
        var emailFld = form.querySelectorAll('[ftype=email]');
        var i;
        for(i = 0; i < emailFld.length; i++){
          var emailVal = emailFld[i].value;
          if((emailVal.replace(/^\\s+|\\s+$/g, '')).length != 0){
            var atpos = emailVal.indexOf('@');
            var dotpos = emailVal.lastIndexOf('.');
            if(atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length){
              alert('Please enter a valid email address.');
              emailFld[i].focus();
              return false;
            }
          }
        }
        return true;
      }
      
      function checkMandatory966770000000627837(){
        var mndFileds = new Array('Company', 'First Name', 'Last Name', 'Designation', 'Email', 'Phone', 'Industry', 'City', 'Zip Code', 'Country');
        var fldLangVal = new Array('Company', 'First Name', 'Last Name', 'Title', 'Email', 'Phone', 'Industry', 'City', 'Zip Code', 'Country');
        for(i = 0; i < mndFileds.length; i++){
          var fieldObj = document.forms['WebToLeads966770000000627837'][mndFileds[i]];
          if(fieldObj){
            if(((fieldObj.value).replace(/^\\s+|\\s+$/g, '')).length == 0){
              if(fieldObj.type == 'file'){
                alert('Please select a file to upload.');
                fieldObj.focus();
                return false;
              }
              alert(fldLangVal[i] + ' cannot be empty.');
              fieldObj.focus();
              return false;
            }
            else if(fieldObj.nodeName == 'SELECT'){
              if(fieldObj.options[fieldObj.selectedIndex].value == '-None-'){
                alert(fldLangVal[i] + ' cannot be none.');
                fieldObj.focus();
                return false;
              }
            }
            else if(fieldObj.type == 'checkbox'){
              if(fieldObj.checked == false){
                alert('Please accept ' + fldLangVal[i]);
                fieldObj.focus();
                return false;
              }
            }
            try{
              if(fieldObj.name == 'Last Name'){
                name = fieldObj.value;
              }
            }
            catch(e){}
          }
        }
        if(!validateEmail966770000000627837()){
          return false;
        }
        if(!privacyAlert966770000000627837()){
          return false;
        }
        var urlparams = new URLSearchParams(window.location.search);
        if(urlparams.has('service') && (urlparams.get('service') === 'smarturl')){
          var webform = document.getElementById('webform966770000000627837');
          var service = urlparams.get('service');
          var smarturlfield = document.createElement('input');
          smarturlfield.setAttribute('type', 'hidden');
          smarturlfield.setAttribute('value', service);
          smarturlfield.setAttribute('name', 'service');
          webform.appendChild(smarturlfield);
        }
        document.querySelector('.crmWebToEntityForm .formsubmit').setAttribute('disabled', true);
      }

      // Functions for the second partner form (966770000000627838)
      function addAriaSelected966770000000627838(){
        var optionElem = event.target;
        var previousSelectedOption = optionElem.querySelector('[aria-selected=true]');
        if(previousSelectedOption){
          previousSelectedOption.removeAttribute('aria-selected');
        }
        optionElem.querySelectorAll('option')[optionElem.selectedIndex].ariaSelected = 'true';
      }
      
      function privacyAlert966770000000627838(){
        var privacyTool = document.getElementById('privacyTool966770000000627838');
        var privacyErr = document.getElementById('privacyErr966770000000627838');
        if(privacyTool != undefined && !privacyTool.checked){
          privacyErr.style.visibility = 'visible';
          privacyTool.ariaInvalid = 'true';
          privacyTool.focus();
          return false;
        }
        return true;
      }
      
      function disableErr966770000000627838(){
        var privacyTool = document.getElementById('privacyTool966770000000627838');
        var privacyErr = document.getElementById('privacyErr966770000000627838');
        if(privacyTool != undefined && privacyTool.checked && privacyErr != undefined){
          privacyErr.style.visibility = 'hidden';
          privacyTool.ariaInvalid = 'false';
        }
      }
      
      function validateEmail966770000000627838(){
        var form = document.forms['WebToLeads966770000000627838'];
        var emailFld = form.querySelectorAll('[ftype=email]');
        var i;
        for(i = 0; i < emailFld.length; i++){
          var emailVal = emailFld[i].value;
          if((emailVal.replace(/^\\s+|\\s+$/g, '')).length != 0){
            var atpos = emailVal.indexOf('@');
            var dotpos = emailVal.lastIndexOf('.');
            if(atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length){
              alert('Please enter a valid email address.');
              emailFld[i].focus();
              return false;
            }
          }
        }
        return true;
      }
      
      function checkMandatory966770000000627838(){
        var mndFileds = new Array('Company', 'First Name', 'Last Name', 'Designation', 'Email', 'Phone', 'Industry', 'City', 'Zip Code', 'Country');
        var fldLangVal = new Array('Company', 'First Name', 'Last Name', 'Title', 'Email', 'Phone', 'Industry', 'City', 'Zip Code', 'Country');
        for(i = 0; i < mndFileds.length; i++){
          var fieldObj = document.forms['WebToLeads966770000000627838'][mndFileds[i]];
          if(fieldObj){
            if(((fieldObj.value).replace(/^\\s+|\\s+$/g, '')).length == 0){
              if(fieldObj.type == 'file'){
                alert('Please select a file to upload.');
                fieldObj.focus();
                return false;
              }
              alert(fldLangVal[i] + ' cannot be empty.');
              fieldObj.focus();
              return false;
            }
            else if(fieldObj.nodeName == 'SELECT'){
              if(fieldObj.options[fieldObj.selectedIndex].value == '-None-'){
                alert(fldLangVal[i] + ' cannot be none.');
                fieldObj.focus();
                return false;
              }
            }
            else if(fieldObj.type == 'checkbox'){
              if(fieldObj.checked == false){
                alert('Please accept ' + fldLangVal[i]);
                fieldObj.focus();
                return false;
              }
            }
            try{
              if(fieldObj.name == 'Last Name'){
                name = fieldObj.value;
              }
            }
            catch(e){}
          }
        }
        if(!validateEmail966770000000627838()){
          return false;
        }
        if(!privacyAlert966770000000627838()){
          return false;
        }
        var urlparams = new URLSearchParams(window.location.search);
        if(urlparams.has('service') && (urlparams.get('service') === 'smarturl')){
          var webform = document.getElementById('webform966770000000627838');
          var service = urlparams.get('service');
          var smarturlfield = document.createElement('input');
          smarturlfield.setAttribute('type', 'hidden');
          smarturlfield.setAttribute('value', service);
          smarturlfield.setAttribute('name', 'service');
          webform.appendChild(smarturlfield);
        }
        document.querySelector('.crmWebToEntityForm .formsubmit').setAttribute('disabled', true);
      }
    `;
    document.head.appendChild(script);

    // Add analytics script with security measures
    const analyticsScript = document.createElement('script');
    analyticsScript.id = 'wf_anal';
    analyticsScript.crossOrigin = 'anonymous';
    analyticsScript.referrerPolicy = 'strict-origin-when-cross-origin';
    analyticsScript.src = 'https://crm.zohopublic.in/crm/WebFormAnalyticsServeServlet?rid=9ca7ead4cce88c8ac85ada4e594ae6b0efe9851d71e2c05dccfe92caefdbb3e1684ca6bfde6629c62ae1506c3857ecb2gida736f7f5c34811de6d2f9160c172216c8808a6879c2a2ffbbfe43eadfee2bd3bgidadf99b548d54a56fd3dfddeb0b54402f1f6380bd38f316dada141cf518ce663cgidda410dec77d54dd8a2c5d45581f9389f422a07bcb3eaf151a028f88649bc0846&tw=ca5309f14ff46f6aafea0b52a91d227300f6149e4392c261cdf16c78242d09b1';
    
    // Add error handling for script loading
    analyticsScript.onerror = () => {
      console.error('Failed to load Zoho analytics script');
    };
    
    document.head.appendChild(analyticsScript);

    return () => {
      // Secure cleanup with error handling
      try {
        if (style.parentNode) document.head.removeChild(style);
        if (script.parentNode) document.head.removeChild(script);
        if (analyticsScript.parentNode) document.head.removeChild(analyticsScript);
      } catch (error) {
        console.warn('Error during script cleanup:', error);
      }
    };
  }, []);

  return null;
};

export default ZohoCRMScript;